/* global React, Icon, Card, CardHead, Button, IconButton, Field, Input, Select, Currency, Segmented, Tabs, Badge, StatusBadge, KPI, Modal, EmptyState, Pagination, FilterPanel, makeFilter, dateInFilter, toast, SectionTitle, INVOICES, CUSTOMERS, SUPPLIERS, PRODUCTS, DataList, fmt, fmt0 */
// PLUMME 2.0 — Shared list building blocks (header, search, pagination, confirm dialog, CRM badge)
// CRM status badge + customer detail (modelled on SalesCustomersTable source)
const crmLabel = (status) => t(PlummeI18n.keyFor('crm', status, 'crm'), t('crm.active'));
function crmBadge(c) { const s = c.crm || 'aktiv'; return <span className={'crm-badge crm-' + s}>{crmLabel(s)}</span>; }
// Deler en oversettelse på en {plassholder} slik at verdien kan rendres med egen
// markup (fet skrift) uansett hvor plassholderen havner i setningen.
function splitAround(key, token, node) {
  const parts = t(key).split('{' + token + '}');
  return <React.Fragment>{parts[0]}{node}{parts[1] || ''}</React.Fragment>;
}
// hover-to-copy text cell
function CopyText({ text }) {
  if (!text) return null;
  return <span className="copy-cell">{text}
    <button className="copy-cell-btn" title={t('list.copy')} onClick={(e) => { e.stopPropagation(); if (navigator.clipboard) navigator.clipboard.writeText(text); toast(t('list.copied', { text }), 'info'); }}><Icon name="copy" size={13} /></button>
  </span>;
}
function SearchField({ value, onChange, placeholder, help }) {
  const [open, setOpen] = useState(false);
  return <div className={'ph-search' + (value ? ' has-val' : '') + (open ? ' open' : '')} {...(help ? { 'data-help': help, 'data-help-title': t('list.search') } : {})}>
    <button type="button" className="ph-search-btn" onClick={() => setOpen(true)} aria-label={t('list.search')} title={t('list.search')}><Icon name="search" size={18} /></button>
    <Input icon="search" placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} />
  </div>;
}
// download dropdown (CSV / Excel) for list page headers.
// Pass exportData={{ filename, columns:[{header,value(row)}], rows }} to get real CSV/Excel downloads.
function DownloadMenu({ exportData, help }) {
  const [open, setOpen] = useState(false);
  const pick = (kind, label) => {
    setOpen(false);
    if (exportData && exportData.rows && exportData.rows.length) {
      window.exportTable(exportData.filename || 'eksport', exportData.columns, exportData.rows, kind);
      toast(t('list.downloaded', { label }), 'success');
    } else {
      toast(exportData ? t('list.nothingToExport') : t('list.downloading', { label }), 'info');
    }
  };
  return <div className="popwrap" {...(help ? { 'data-help': help, 'data-help-title': t('list.export') } : {})}>
    <IconButton name="download" onClick={() => setOpen((o) => !o)} aria-label={t('list.download')} title={t('list.export')} />
    {open && <React.Fragment>
      <div className="pop-scrim" onClick={() => setOpen(false)} />
      <div className="pop pop-menu right">
        <button onClick={() => pick('csv', 'CSV')}><Icon name="fileText" size={18} />{t('set.csv')}</button>
        <button onClick={() => pick('xls', 'Excel .xlsx')}><Icon name="files" size={18} />Excel .xlsx</button>
      </div>
    </React.Fragment>}
  </div>;
}
function PageHeader({ title, subtitle, tools, onAdd, addLabel, children, card = true, exportData, help, titleHelp, uploadHelp, downloadHelp, addHelp, headerTools, className = '' }) {
  const row = <div className={('ph-row ' + className).trim()}>
    <div className="ph-title"><div><h2 className="t-h1" {...(titleHelp ? { 'data-help': titleHelp, 'data-help-title': title } : {})}>{title}</h2>{subtitle && <div className="t-sm muted">{subtitle}</div>}</div></div>
    {headerTools ? headerTools : <React.Fragment>{tools && <IconButton name="upload" title={t('list.upload')} aria-label={t('list.upload')} {...(uploadHelp ? { 'data-help': uploadHelp, 'data-help-title': t('list.upload') } : {})} />}{tools && <DownloadMenu exportData={exportData} help={downloadHelp} />}</React.Fragment>}
    {children}
    {onAdd && <Button icon="plus" onClick={onAdd} title={addLabel || t('list.add')} {...(addHelp ? { 'data-help': addHelp, 'data-help-title': addLabel } : {})}><span className="add-label">{addLabel}</span></Button>}
  </div>;
  return card ? <Card pad={false} className="pg-card" style={{ padding: '18px 22px', marginBottom: 18 }}>{row}</Card> : row;
}
function ListShell({ title, subtitle, searchPh, search, setSearch, onAdd, addLabel, children, filter, splitList, tools = true, exportData, headerTools, help, titleHelp, uploadHelp, downloadHelp, addHelp, searchHelp, noHeaderSearch }) {
  return <Card pad={false} className="pg-card list-card" style={{ padding: '22px 24px' }}>
    <PageHeader title={title} subtitle={subtitle} tools={tools} onAdd={onAdd} addLabel={addLabel} card={false} exportData={exportData} help={help} titleHelp={titleHelp} uploadHelp={uploadHelp} downloadHelp={downloadHelp} addHelp={addHelp}>
      {headerTools}
      {!noHeaderSearch && setSearch && <SearchField value={search} onChange={setSearch} placeholder={searchPh} help={searchHelp} />}
      {!noHeaderSearch && (filter || <Button variant="secondary" icon="filter" title={t('ui.filter')}>{t('ui.filterChoices')}</Button>)}
    </PageHeader>
    <div style={{ marginTop: 18, paddingTop: 18, borderTop: '1px solid var(--border)' }}>{children}</div>
  </Card>;
}
// Tynn spesialisering av den delte `ConfirmModal` for liste-rader: arkiver- og
// slett-varianten deler alt bortsett fra tekstnokler.
function ConfirmDelete({ open, name, onClose, onConfirm, archive, bodyKey }) {
  return <ConfirmModal open={open} onClose={onClose} onConfirm={onConfirm}
    title={archive ? t('list.archiveTitle') : t('list.deleteTitle')}
    confirmLabel={archive ? t('list.archiveConfirm') : t('list.delete')}>
    {splitAround(bodyKey || (archive ? 'list.archiveBody' : 'list.deleteBody'), 'name', <b>{name}</b>)}
  </ConfirmModal>;
}
function usePaged(items, size = 10) {
  const [page, setPage] = useState(1);const [ps, setPs] = useState(size);
  const pages = Math.max(1, Math.ceil(items.length / ps));
  const cur = Math.min(page, pages);
  const slice = items.slice((cur - 1) * ps, cur * ps);
  return { slice, page: cur, setPage, pages, ps, setPs, total: items.length, from: items.length ? (cur - 1) * ps + 1 : 0, to: Math.min(cur * ps, items.length) };
}
Object.assign(window, { PageHeader, ListShell, usePaged, CopyText, crmBadge, crmLabel, splitAround, DownloadMenu, SearchField });
